import { getApiCurrentLanguage, translate } from "./functions";
import axios from "axios";
import proj4 from "proj4";

export const domain = "https://dedalo.oroibidea.es";
const URL_SERVER = domain + "/dedalo/lib/dedalo/publication/server_api/v1/json";
// const db_name = "web_oroibidea_pre";
// const code = "inm3014rtAw_testimonios_PRE";

const db_name = 'dedalo4_public';
const code = 'inm3014rtAw_testimonios';


const records = "/records";
const language = getApiCurrentLanguage();
export const base_path = "/dispromedia/web_oh/";
const tableCenso = "franco_symbology_census";
const tableExpo = "ts_simbolos_de_un_tiempo";
const periodParent = "navarra261_1";

export async function getPeriods() {
  var params = new URLSearchParams({
    resolve_portal: false,
    resolve_portals_custom:
      '{"image":"image", "childrens.image":"image", "childrens": "ts_simbolos_de_un_tiempo", "childrens.childrens": "ts_simbolos_de_un_tiempo"}',
    resolve_dd_relations: false,
    order: "norder ASC",
  }).toString();
  return await axios
    .post(
      URL_SERVER +
        records +
        "?code=" +
        code +
        "&db_name=" +
        db_name +
        "&lang=lg-" +
        language +
        "&sql_filter=parents='[\"navarra261_1\"]' and term is not null" +
        "&table=" +
        tableExpo +
        "&" +
        params
    )
    .then((res) => {
      return res.data.result ? res.data.result : null;
    })
    .then((res) => {
      return res.map((period) => {
        const duplicatedTerms = [
          "navarra261_23",
          "navarra261_5",
          "navarra261_25",
        ];

        const regex =
          /(.*)\((\d{4})(?:tik\s*(\d{4}|gaur\s*arte)|\s*-\s*(\d{4}|presente))?\)/;
        const matches = period.term.match(regex);
        if (matches) {
          period.title = matches[1].trim();
          period.start = matches[2].trim();

          // Manejar diferentes casos para period.end
          let endDate = matches[3]
            ? matches[3].trim()
            : matches[4]
            ? matches[4].trim()
            : "";

          period.end = endDate;
        }

        if (period.image && period.image.length > 0) {
          period.image = period.image[0];
        } else {
          period.image = null;
        }

        period.childrens.map((year) => {
          year.title = year.term;
          if (year.image && year.image.length > 0) {
            year.image = year.image[0];
          } else {
            year.image = null;
          }
          year.body = [year.body];

          return year;
        });

        const duplicat = period.childrens.filter((value) =>
          duplicatedTerms.includes(value.term_id)
        );
        if (duplicat.length > 0) {
          duplicat.forEach((copy) => {
            period.childrens.map((year) => {
              if (year.term === copy.term) {
                year.body = [...year.body, ...copy.body];
                year.image2 = copy.image;
                return year;
              }
            });
          });
        }
        period.childrens = period.childrens.filter(
          (value) => !duplicatedTerms.includes(value.term_id)
        );

        return period;
      });
    });
}

export async function getPeriod(section_id) {
  var params = new URLSearchParams({
    resolve_portal: false,
    resolve_portals_custom: '{"image":"image"}',
    resolve_dd_relations: false,
  }).toString();
  return await axios
    .post(
      URL_SERVER +
        records +
        "?code=" +
        code +
        "&db_name=" +
        db_name +
        "&table=" +
        tableExpo +
        "&lang=lg-" +
        language +
        "&" +
        params +
        "&parent=" +
        periodParent +
        "&section_id=" +
        section_id
    )
    .then((res) => {
      return res.data.result[0] ? res.data.result[0] : null;
    });
}

export async function getPeriodYears(parent) {
  return await axios
    .post(
      URL_SERVER +
        records +
        "?code=" +
        code +
        "&db_name=" +
        db_name +
        "&lang=lg-" +
        language +
        "&sql_filter=parents='[\"" +
        parent +
        "\"]'" +
        "&table=" +
        tableExpo
    )
    .then((res) => {
      return res.data.result ? res.data.result : null;
    });
}

export async function getYear(section_id) {
  var params = new URLSearchParams({
    resolve_portal: false,
    resolve_portals_custom: '{"image":"image"}',
    resolve_dd_relations: false,
  }).toString();
  return await axios
    .post(
      URL_SERVER +
        records +
        "?code=" +
        code +
        "&db_name=" +
        db_name +
        "&table=" +
        tableExpo +
        "&lang=lg-" +
        language +
        "&" +
        params +
        "&section_id=" +
        section_id
    )
    .then((res) => {
      return res.data.result[0] ? res.data.result[0] : null;
    });
}

export async function getTypologies() {
  return await axios
    .post(
      URL_SERVER +
        records +
        "?code=" +
        code +
        "&db_name=" +
        db_name +
        "&lang=lg-" +
        language +
        "&table=" +
        tableCenso
    )
    .then((res) => {
      // console.log(res.data.result);
      // const vidrieras = res.data.result.filter(item => item.typology.includes("calles"));

      // console.log(res.data.result.length);
      return res.data.result ? res.data.result : null;
    })
    .then((res) => {
      const tipologias = Object.entries(
        res.reduce((acc, item) => {
          if (item.typology_data && item.typology) {
            acc[item.typology_data] = item.typology;
          }
          return acc;
        }, {})
      ).map(([typology_data, typology]) => ({ typology_data, typology }));

      return tipologias;
    });
}

export async function getAllMapData() {
  return await axios
    .post(
      URL_SERVER +
        records +
        "?code=" +
        code +
        "&db_name=" +
        db_name +
        "&lang=lg-" +
        language +
        "&table=" +
        tableCenso
    )
    .then((res) => {
      return res.data.result ? res.data.result : null;
    }).then;
}

export async function getAllMapsMarks() {
  var params = new URLSearchParams({
    resolve_portal: false,
    resolve_portals_custom: '{"identify_image_data":"image"}',
    resolve_dd_relations: false,
  }).toString();

  return await axios
    .post(
      URL_SERVER +
        records +
        "?code=" +
        code +
        "&db_name=" +
        db_name +
        "&table=" +
        tableCenso +
        // "&sql_filter=location_geojson is not null" +
        "&lang=lg-" +
        language +
        "&" +
        params +
        "&limit=0"
    )
    .then((res) => {
      return res.data.result ? res.data.result : null;
    })
    .then((res) => {
      if (res === null) {
        return null;
      }

      var SITNA = window.SITNA;
      const layersArray = [];
      res.map((value) => {
        // if (value.location_geojson !== "") {
        //   // console.log(layer_data);
        //   value.location = JSON.parse(
        //     value.location_geojson
        //   )[0].layer_data.features[0].geometry.coordinates;
        // } else {
        //   value.location = null;
        //   console.log(value);
        // }

        if (value.location_geojson !== "") {
          try {
            const parsedGeoJSON = JSON.parse(value.location_geojson);

            if (parsedGeoJSON[0] && parsedGeoJSON[0].layer_data) {
              const layerData = parsedGeoJSON[0].layer_data;

              if (layerData.features && layerData.features.length > 0) {
                value.location = layerData.features[0].geometry.coordinates;
              } else {
                value.location = null;
                // console.log('El objeto no tiene la propiedad "features" o está vacío:', value);
              }
            } else {
              value.location = null;
              // console.log('layer_data es null o undefined:', value);
            }
          } catch (error) {
            value.location = null;
            // console.error('Error al parsear el geojson:', error, value);
          }
        } else {
          value.location = null;
          // console.log(value);
        }

        const typologyData = value.typology_data;
        let layer = layersArray.find(
          (layer) => layer.typologyData === typologyData
        );

        if (!layer) {
          layer = {
            typologyData: typologyData,
            layer: new SITNA.layer.Vector(),
          };
          layersArray.push(layer);
        }

        if (value.municipality_rec !== null) {
          let patron = /^[^,]+/;
          let matchMuni = value.municipality_rec.match(patron);

          if (matchMuni) {
            value.localidad = matchMuni[0];
          }
        } else {
          value.localidad = null;
        }

        const popupContent = `
          <div className="map-popup-content">
            <div class="marker-data-list">
              <ul class="popupMap">

                ${
                  value.identify_image_data[0]
                    ? `<li><img loading="lazy" src=${
                        domain + value.identify_image_data[0].image
                      } alt="" /></li>`
                    : ""
                }
                ${
                  value.typology
                    ? `<li><strong>${translate("Tipología")}: <br></strong>${
                        value.typology
                      }</li>`
                    : ""
                }
                ${
                  value.plate_model
                    ? `<li><strong>${translate(
                        "Modelo de placa"
                      )}: <br></strong>${value.plate_model}</li>`
                    : ""
                }
                ${
                  value.description
                    ? `<li><strong>${translate("Descripción")}: <br></strong>${
                        value.description
                      }</li>`
                    : ""
                }
                ${
                  value.place
                    ? `<li><strong>${translate("Localización")}: <br></strong>${
                        value.place
                      }</li>`
                    : ""
                }
                ${
                  value.localidad
                    ? `<li><strong>${translate("Localidad")}: <br></strong>${
                        value.localidad
                      }</li>`
                    : ""
                }


              </ul>
            </div>
          </div>`;

        const locUTM = proj4("EPSG:4326", "EPSG:25830", value.location);

        layer.layer.addMarker(locUTM, {
          data: popupContent,
          width: 22,
          cssClass: "tc-marker2",
        });
      });
      return layersArray;
    });
}

export async function getMapDataByTypology(typology) {
  var params = new URLSearchParams({
    // sql_filter: "victim = '[\""+section_id+"\"]' and ref_victim_typology_data like '%\"1\"%'",
    sql_filter: "typology_data = '" + typology + "' ",
  }).toString();

  return await axios
    .post(
      URL_SERVER +
        records +
        "?code=" +
        code +
        "&sql_filter=typology_data like" +
        typology +
        "&db_name=" +
        db_name +
        "&lang=lg-" +
        language +
        "&table=" +
        tableCenso +
        "&" +
        params
    )
    .then((res) => {
      return res.data.result ? res.data.result : null;
    });
}
